<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true"
          >บันทึกข้อมูลเรียบร้อย !</v-alert
        >
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-2">
          <v-card-title> ข้อมูลโปรโมชั่น </v-card-title>
          <v-card-text>
            <v-form ref="input_form" @submit.prevent="create()">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    prepend-inner-icon="mdi-bookmark-minus"
                    color="#86bc3a"
                    type="text"
                    label="ชื่อโปรโมชั่น"
                    v-model="promotion_data.promotion_title"
                    hide-details="auto"
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="3" xl="3" class="pb-0">
                  <v-menu
                    ref="menu_date_start"
                    v-model="menu_date_start"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        color="#86bc3a"
                        clearable
                        class="input_width"
                        v-model="promotion_data.date_start"
                        label="วันที่สิ้นสุดโปรโมชั่น"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="TH"
                      color="#86bc3a"
                      v-model="promotion_data.date_start"
                      no-title
                      scrollable
                      @input="menu_start = false"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="3" xl="3" class="pb-0">
                  <v-menu
                    ref="menu_date_end"
                    v-model="menu_date_end"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        color="#86bc3a"
                        clearable
                        class="input_width"
                        v-model="promotion_data.date_stop"
                        label="วันที่สิ้นสุดโปรโมชั่น"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="TH"
                      color="#86bc3a"
                      v-model="promotion_data.date_stop"
                      no-title
                      scrollable
                      @input="menu_end = false"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="3" xl="3" class="pb-0">
                  <v-text-field
                    prepend-inner-icon="mdi-alpha-s-circle"
                    color="#86bc3a"
                    type="number"
                    label="จำนวนสินค้าที่ต้องซื้อ"
                    @keypress="isCurrency($event, promotion_data.promotion_buy)"
                    v-model="promotion_data.promotion_buy"
                    hide-details="auto"
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="3" xl="3" class="pb-0">
                  <v-text-field
                    prepend-inner-icon="mdi-package-variant"
                    color="#86bc3a"
                    type="number"
                    label="จำนวนสินค้าที่แถม"
                    @keypress="
                      isCurrency($event, promotion_data.promotion_free)
                    "
                    v-model="promotion_data.promotion_free"
                    hide-details="auto"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="pt-0">
                  <v-textarea
                    color="#86bc3a"
                    type="text"
                    label="รายละเอียด"
                    v-model="promotion_data.promotion_detail"
                    hide-details="auto"
                    outlined
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <label for=""> สาขาที่ต้องการจัดโปรโมชั่น </label>
                </v-col>

                <v-col>
                  <v-radio-group v-model="promotion_data.type" class="mt-0">
                    <div class="d-flex">
                      <div class="d-flex mr-1">
                        <div>
                          <v-radio color="#86bc3a" :value="0"></v-radio>
                        </div>
                        <div>ทุกสาขา</div>
                      </div>
                      <div class="d-flex ml-6">
                        <div>
                          <v-radio color="#86bc3a" :value="1"></v-radio>
                        </div>
                        <div>เลือกสาขาที่ต้องการ</div>
                      </div>
                    </div>
                  </v-radio-group>
                </v-col>
                <v-col v-if="promotion_data.type == 1" cols="12">
                  <v-select
                    v-model="promotion_data.store"
                    :items="store_data"
                    item-text="store_name"
                    item-value="id"
                    label="เลือกสาขา"
                    multiple
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip>
                        <span>{{ item.store_name }}</span>
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <label for=""> สินค้าที่เข้าร่วมโปรโมชั่น </label>
                </v-col>

                <v-col cols="6" md="7" lg="9" xl="10" class="pt-0">
                  <v-autocomplete
                    color="#86bc3a"
                    :items="product_data"
                    item-text="product_name"
                    item-value="id"
                    @change="getUnit"
                    label="สินค้าที่เข้าร่วมโปรโมชั่น"
                    hide-details="auto"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6" md="5" lg="3" xl="2" class="pt-0">
                  <v-select
                    color="#86bc3a"
                    :items="unit_data"
                    item-text="unit_name"
                    item-value="id"
                    label="หน่วยนับ"
                    @change="addProduct"
                    hide-details="auto"
                    outlined
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">ชื่อสินค้า</th>
                          <th class="text-left">หน่วยนับ</th>
                          <th class="text-left">ราคา</th>
                          <th class="text-left">ลบ</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in product_list"
                          :key="index"
                          :class="item.is_delete == 1 ? 'd-none' : ''"
                        >
                          <td class="py-5">{{ item.product_name }}</td>
                          <td>{{ item.unit_name }}</td>
                          <td>{{ item.price }}</td>
                          <td>
                            <v-btn
                              small
                              height="42"
                              class="grad-danger-bg white--text mr-1 mb-1"
                              @click="removeProduct(index)"
                              title="ลบข้อมูล"
                            >
                              <v-icon>mdi-delete-empty-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>

              <div class="text-center pt-6">
                <v-btn
                  large
                  class="white--text grad-success-bg mobile_btn"
                  style="font-size: 18px"
                  type="submit"
                  >บันทึก</v-btn
                >
              </div>
            </v-form>
          </v-card-text>
        </div>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
            indeterminate
            size="70"
            width="7"
            color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
// import Swal from "sweetalert2";
// import {HTTP} from "@/axios";
import { formatPrice, onlyForCurrency } from "@/js/handler";
// import Swal from "sweetalert2";
import { HTTP_ARIN } from "@/axios_arin";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Promotion_add_pos_free",
  data() {
    return {
      loading_page: false,
      loading_data: false,
      overlay: false,
      alert_success: false,
      alert_tracking: false,
      title_type: 0,
      sortDesc: false,
      search: null,
      menu_date_start: null,
      menu_date_end: null,
      temp_date: "",
      promotion_data: {
        promotion_title: null,
        promotion_type: 0,
        promotion_buy: null,
        promotion_free: null,
        promotion_detail: null,
        date_start: null,
        date_stop: null,
        type: null,
        promotion_list: [],
        store: [],
      },
      store_data: [],
      product_data: [],
      product_id: null,
      product_list: [],
      unit_data: [],
      save_promotion: {
        date_start: null,
        date_end: null,
      },
      footer_Props: {
        "items-per-page-text": "รายการต่อหน้า",
      },
      items_select: [
        { id: 0, name: "ไม่มี" },
        { id: 1, name: "inj.GLUCOSE 20 CC for *INJection* 10.-" },
        { id: 2, name: "ยาดม IZE JELLI BALM 7 G 29.-" },
      ],
      items_select_sub: [
        { id: 0, name: "ไม่มี" },
        { id: 1, name: "ชิ้น" },
        { id: 2, name: "กล่อง" },
      ],

      data_list: [
        {
          product_name: "inj.GLUCOSE 20 CC for *INJection* 10.-",
          unit: "ชิ้น",
          price: "10.00",
        },
        {
          product_name: "ยาดม IZE JELLI BALM 7 G 29.-",
          unit: "ชิ้น",
          price: "20.00",
        },
      ],
    };
  },
  methods: {
    async getStore() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/promotion/pharma/get/store", config).then((res) => {
        if (res.data.successful === true) {
          this.store_data = res.data.data;
        }
      });
    },
    async getPromotionByID() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let id = this.$route.query.id;
      await HTTP_ARIN.get(`/promotion/pharma/get/by/${id}`, config).then(
        async (res) => {
          if (res.data.successful === true) {
            this.promotion_data = res.data.data;
            this.promotion_data = {
              ...this.promotion_data,
              store:
                this.promotion_data.type == 1
                  ? this.promotion_data.store_list.map((item) => {
                      return item.store_id;
                    })
                  : [],
            };
            this.product_list = await res.data.data.promotion_list.map(
              (item) => {
                return {
                  product_id: item.id,
                  product_code: item.product_code,
                  product_name: item.product_name,
                  price: item.price,
                  unit_name: item.unit_name,
                  unit_id: item.productlists_id,
                  is_delete: item.is_delete,
                };
              }
            );
          }
        }
      );
    },
    async getProduct() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/promotion/pharma/get/product", config).then((res) => {
        if (res.data.successful === true) {
          this.product_data = res.data.data;
        }
      });
    },
    async getUnit(id) {
      this.product_id = id;
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/promotion/pharma/get/product/list/" + id, config).then(
        (res) => {
          if (res.data.successful === true) {
            this.unit_data = res.data.data;
          }
        }
      );
    },
    async addProduct(id) {
      let product = this.product_data.find((o) => o.id == this.product_id);
      let unit = this.unit_data.find((o) => o.id == id);
      let data = this.product_list.find(
        (o) => o.id == this.product_id && o.unit_id == id
      );
      if (data == null) {
        this.product_list.push({
          ...product,
          unit_name: unit.unit_name,
          unit_id: unit.id,
          price: unit.price != null ? unit.price : null,
          is_delete: 0,
        });
      }
    },
    async removeProduct(index) {
      this.loading_page = true;
      this.product_list[index] = await {
        ...this.product_list[index],
        is_delete: 1,
      };
      this.loading_page = false;
    },
    async create() {
      let data = {
        promotion_code: this.promotion_data.promotion_code,
        promotion_title: this.promotion_data.promotion_title,
        promotion_type: this.promotion_data.promotion_type,
        promotion_buy: this.promotion_data.promotion_buy,
        promotion_free: this.promotion_data.promotion_free,
        promotion_detail: this.promotion_data.promotion_detail,
        date_start: this.promotion_data.date_start,
        date_stop: this.promotion_data.date_stop,
        type: this.promotion_data.type,
        promotion_list: this.product_list.map((o) => {
          if (o.product_id && o.is_delete == 0) {
            return {
              id: o.product_id,
              product_code: o.product_code,
              productlists_id: o.unit_id,
            };
          } else if (!o.product_id && o.is_delete == 0) {
            return {
              product_code: o.product_code,
              productlists_id: o.unit_id,
            };
          } else if (o.product_id && o.is_delete == 1) {
            return {
              id: o.product_id,
              product_code: o.product_code,
              productlists_id: o.unit_id,
              is_delete: o.is_delete,
            };
          }
        }),
        store_list:
          this.promotion_data.type == 0
            ? await this.store_data.map((o) => {
                // let data = this.promotion_data.store_list.find(
                //   (item) => o.id == item.store_id
                // );
                // if (data != null) {
                //   return {
                //     id: data.id,
                //     store_id: data.store_id,
                //   };
                // } else {
                  return {
                    id: null,
                    store_id: o.id,
                  };
                // }
              })
            : await this.promotion_data.store.map((element) => {
                // if (
                //   this.promotion_data.store.filter(
                //     (element2) => element2 == element.store_id
                //   ).length > 0
                // ) {
                  // return { id: element.id, store_id: element.store_id };
                  return { id: null, store_id: element };
                // } 
                // else {
                //   return { id: null, store_id: element.store_id };
                // }
              }),
      };
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let id = this.$route.query.id;
      HTTP_ARIN.post("/promotion/pharma/edit/by/" + id, data, config).then(
        (res) => {
          if (res.data.successful === true) {
            this.alert_success = true;
            setTimeout(() => {
              (this.alert_success = false),
                this.$router.push("/promotioninformation");
            }, 2000);
          }
        }
      );
    },
    format_price: function (value) {
      return formatPrice(value);
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number);
    },
    get_detail() {
      this.$router.push("");
    },
    minDate() {
      const today = new Date();
      let month = today.getMonth() + 1;
      let date = today.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      const result_date = today.getFullYear() + "-" + month + "-" + date;
      return result_date;
    },
    diffDateTH_start(value) {
      const diff = value.split("-");
      const day = diff[2];
      const month = diff[1];
      const year = parseInt(diff[0]) + 543;
      const final_date = day + "-" + month + "-" + year;
      return (this.save_promotion.date_start = final_date);
    },
    diffDateTH_end(value) {
      const diff = value.split("-");
      const day = diff[2];
      const month = diff[1];
      const year = parseInt(diff[0]) + 543;
      const final_date = day + "-" + month + "-" + year;
      return (this.save_promotion.date_end = final_date);
    },
  },
  mounted() {
    // this.page(0)
    this.getStore();
    this.getProduct();
    this.getPromotionByID();
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}

.font-18 {
  font-size: 18px;
}

.font-16 {
  font-size: 16px;
}

.color-grey {
  color: #909090;
}
</style>
